var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',{ref:"formRailSplit",staticClass:"fill-height",attrs:{"lazy-loading":""}},[_c(_vm.componentToShow,{ref:"formSplitRouting",tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }